import { render, staticRenderFns } from "./cModalViewCarritoNota.vue?vue&type=template&id=6c36dc0d"
import script from "./cModalViewCarritoNota.vue?vue&type=script&lang=js"
export * from "./cModalViewCarritoNota.vue?vue&type=script&lang=js"
import style0 from "./cModalViewCarritoNota.vue?vue&type=style&index=0&id=6c36dc0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports